var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.273 10.625v.875H7.727v-.875c0-.437.346-.875.864-.875h13.818c.519 0 .864.35.864.875ZM7.727 15h15.546v4.375c0 .438-.432.875-.864.875H8.591c-.518 0-.864-.35-.864-.875V15Zm.864-7C7.123 8 6 9.137 6 10.625v8.75C6 20.863 7.123 22 8.59 22h13.82c1.467 0 2.59-1.137 2.59-2.625v-8.75C25 9.137 23.877 8 22.41 8H8.59Zm7.773 8.75H9.455v1.75h6.91v-1.75Z",
    fill: "#1D352A",
    fillOpacity: 0.5
  })));
};
export default SvgCard;